module.exports = __webpack_public_path__ + "img/Logo_la_Padroneta_errada.7a8e916b.png";